var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiUserIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "url(#paint0_linear_114_2819)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9C17.4946 9 18.4484 9.39509 19.1517 10.0983C19.8549 10.8016 20.25 11.7554 20.25 12.75C20.25 13.7446 19.8549 14.6984 19.1517 15.4017C18.4484 16.1049 17.4946 16.5 16.5 16.5C15.5054 16.5 14.5516 16.1049 13.8483 15.4017C13.1451 14.6984 12.75 13.7446 12.75 12.75C12.75 11.7554 13.1451 10.8016 13.8483 10.0983C14.5516 9.39509 15.5054 9 16.5 9ZM16.5 10.875C16.0027 10.875 15.5258 11.0725 15.1742 11.4242C14.8225 11.7758 14.625 12.2527 14.625 12.75C14.625 13.2473 14.8225 13.7242 15.1742 14.0758C15.5258 14.4275 16.0027 14.625 16.5 14.625C16.9973 14.625 17.4742 14.4275 17.8258 14.0758C18.1775 13.7242 18.375 13.2473 18.375 12.75C18.375 12.2527 18.1775 11.7758 17.8258 11.4242C17.4742 11.0725 16.9973 10.875 16.5 10.875ZM16.5 17.4375C19.0031 17.4375 24 18.6844 24 21.1875V24H9V21.1875C9 18.6844 13.9969 17.4375 16.5 17.4375ZM16.5 19.2188C13.7156 19.2188 10.7813 20.5875 10.7813 21.1875V22.2188H22.2188V21.1875C22.2188 20.5875 19.2844 19.2188 16.5 19.2188Z",
    fill: "#5A5A5A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_114_2819",
    x1: 16.5,
    y1: 0,
    x2: 16.5,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D4D4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiUserIcon);
export default __webpack_public_path__ + "static/media/aiUserIcon.eacafeb439d300a742be41d2e1c0cd2a.svg";
export { ForwardRef as ReactComponent };